'use strict'

function initializeHeaderSubnav() {
  $(document).ready(function () {
    $('.header-vts__nav-item > a, .header-vts__nav-item > button').on('click', function (e) {
      e.preventDefault();
      if ($(this).parent().hasClass("header-vts__nav-item--open")) {
        $(this).parent().removeClass('header-vts__nav-item--open');
      } else {
        document.querySelectorAll('.header-vts__nav-item--open').forEach((item) => {
          item.classList.remove('header-vts__nav-item--open');
        })
        this.parentNode.classList.add('header-vts__nav-item--open');
      }
    });

    $('.header-vts__search-close').on('click', function () {
      $('.header-vts__search--open').removeClass('header-vts__search--open');
    });

    $('a').on('keyup', function (e) {
      if (e.which == 9) {
        $('body').addClass("tabUser");
      }
    });

    $('.header-vts__search-input').on('focus', function () {
      $('.header-vts__search').addClass('header-vts__search--active');
    });

    $(document).on('click', function (e) {
      if (!e.target.closest('.header-vts__search')) {
        $('.header-vts__search').removeClass('header-vts__search--active');
      }
      if (!e.target.closest('.header-vts__nav-item')) {

        $('.header-vts__nav-item--open').removeClass('header-vts__nav-item--open');
      }
    });

    $('.header-vts__search-btn').on('click', function () {
      $('.header-vts__search').addClass('header-vts__search--open');
    });
  });
}

export default initializeHeaderSubnav


